import { Button, Modal, useLoading, useIsVisible } from "best-common-react";
import React, { memo, RefObject, useRef, useState, lazy, Suspense } from "react";
import { bulkRefundGame } from "../../../api/RequesTixApi";
import { GamePreviewDTO } from "../../../types/Game";
import { TicketRequestDTO } from "../../../types/TicketRequest";
import GamePreviewDisplay from "../../game/GamePreviewDisplay";
const AdminRequestTable = lazy(() => import("./AdminRequestTable"));

type RefundGameModalProps = {
  show: boolean;
  game: GamePreviewDTO;
  onClose: () => void;
};

const RefundGameModal = ({ show, game, onClose }: RefundGameModalProps) => {
  const { setLoading } = useLoading();

  const refundGame = async () => {
    if (game.gamePk) {
      setLoading(true);
      await bulkRefundGame(game.gamePk);
      onClose();
      setLoading(false);
    }
  };

  return !!game ? (
    <Modal show={show} size="lg">
      <Modal.Header close={onClose}>Are you sure?</Modal.Header>
      <Modal.Body>
        <GamePreviewDisplay game={game} />
        <div className="bcr-mt-3">
          <b>Are you sure you want to bulk refund this game?</b>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button variant="primary" className="bcr-me-2" disabled={!game.gamePk} onClick={() => refundGame()}>
            Refund Game
          </Button>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  ) : null;
};

type AdminRequestsGameProps = {
  game: GamePreviewDTO;
  requests: TicketRequestDTO[];
  showHeader?: boolean;
  jumpToRequestId?: string | number;
};

const AdminRequestsGame = memo(
  ({ game, requests = [], showHeader = false, jumpToRequestId }: AdminRequestsGameProps) => {
    const [showRefund, setShowRefund] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);
    const isVisible = useIsVisible(ref as RefObject<HTMLElement>, true, 0);

    return (
      <div ref={ref}>
        {!!game && (
          <div className="d-flex align-items-center bcr-my-2">
            <GamePreviewDisplay game={game} />
            {showRefund && !!game && (
              <RefundGameModal game={game} show={showRefund} onClose={() => setShowRefund(false)} />
            )}
            <Button variant="default" className="bcr-ms-2" onClick={() => setShowRefund(true)}>
              Refund Game
            </Button>
          </div>
        )}

        {!!(requests.length > 0 || showHeader) && (
          <Suspense fallback={null}>
            {isVisible && (
              <AdminRequestTable requests={requests} jumpToRequestId={jumpToRequestId} visible={isVisible} />
            )}
          </Suspense>
        )}
      </div>
    );
  },
);

export default AdminRequestsGame;
